export default {
    mounted(el, binding) {
        el.style.textAlign = 'right';
        let isUpdating = false;

        const format = (value) => {
            if (value == null || value === '') return '';
            const [int, dec] = value.toString().replace(/,/g, '').split('.');
            const formatted = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return dec != null ? `${formatted}.${dec}` : formatted;
        };

        const updateValue = (formattedValue) => {
            isUpdating = true;
            el.value = formattedValue;

            // Trigger input event to update v-model
            const event = new Event('input', { bubbles: true });
            el.dispatchEvent(event);
            isUpdating = false;
        };

        el.addEventListener('input', (e) => {
            if (isUpdating) return; // Prevent recursive loop

            // Remove commas and filter out any non-digit and non-dot characters
            let raw = e.target.value.replace(/,/g, '');

            // Allow only digits and one decimal point
            // Remove all characters except digits and dot
            raw = raw.replace(/[^\d.]/g, '');

            // If more than one dot, keep only first one
            const parts = raw.split('.');
            if (parts.length > 2) {
                raw = parts.shift() + '.' + parts.join('');
            }

            //REMOVE LEADING ZERO
            if (raw.length > 1 && raw.startsWith('0') && !raw.startsWith('0.')) {
                raw = raw.replace(/^0+/, '');
            }

            const formatted = format(raw);

            if (e.target.value !== formatted) {
                updateValue(formatted);
            }
        });

        // Initialize formatting if value is provided
        if (binding.value != null) {
            el.value = format(binding.value.toString());
        }
    }
};
